<mat-card>
	<mat-card-header>
		<h3>{{"RefinementOfferTitle" | translate}}</h3>
	</mat-card-header>
	<mat-card-content class="margin-left">
		<p>{{"RefinementOffer1" | translate: ({aligners: plannedAligners })}}</p>
		<p>{{"RefinementOffer2" | translate: ({price: packagePrice})}}</p>
	</mat-card-content>
	<br>
	<mat-card-actions class="margin-left">
		<div class="refinement-button-wrapper">
			<button mat-raised-button color="primary"
				(click)="onReleaseRefinementButtonClicked()">
				{{'RefinementRelease' | translate}}
			</button>
			<button mat-raised-button color="primary"
				(click)="onRejectRefinementButtonClicked()">
				{{'RefinementReject' | translate}}
			</button>
		</div>
	</mat-card-actions>
</mat-card>
